/* istanbul ignore file */

const baseStyle = ({ colorMode }) => ({
  color: colorMode === "dark" ? "white" : "black",
});

const heading = {
  baseStyle,
};

export default heading;
